import { TranslatableError } from '@/errors';
import { PiniaPluginContext } from 'pinia';

function TranslatableErrorHandlerPiniaPlugin({ store }: PiniaPluginContext) {
  store.$onAction(({ name, onError }) => {
    onError(e => {
      throw e instanceof TranslatableError ? e : new TranslatableError(`errors.${store.$id}.${name}`, e);
    });
  });
}

export default TranslatableErrorHandlerPiniaPlugin;
